/** 임베드 iframe URL 생성 — app.ts embedUrlFor에서 추출. window/import.meta 의존은 ctx 주입. */

export interface EmbedConfig {
  path: string;
  prodPrefix: string;
  title: string;
  icon: string;
}

export interface EmbedContext {
  origin: string;
  selectedTeamId: string;
  reloadKey: number;
  /** admin URL에 `?demo=1`이 있으면 임베드 앱에도 전달 (디자인 검토용 강제 더미데이터). */
  forceDemo?: boolean;
}

export function embedUrl(cfg: EmbedConfig | undefined, ctx: EmbedContext): string {
  if (!cfg) {
    return "";
  }
  /* dev·prod 모두 **같은 출처의 경로**다 — 예전에는 dev 만
     `http://{hostname}:{devPort}` 로 갈라져 iframe 안팎의 세션이 따로 놀았고,
     조직이 어긋나도 화면에 신호가 없었다(2026-08-20 실측). 이제 admin dev
     서버가 `/hr-system/*` 같은 경로를 각 앱으로 프록시하므로(vite.config 의
     embedProxy) 주소 모양이 운영과 같아지고, 갈래가 하나로 줄어든다. */
  const base = `${ctx.origin}${cfg.prodPrefix}${cfg.path}`;
  /* chrome-less(embedded=1) 지원 앱은 iframe 안에서 자체 LNB/헤더를 숨긴다.
     team-manager는 추가로 admin의 선택 팀을 넘겨받는다. */
  const isTeamManager = cfg.prodPrefix === "/team-manager";
  const isChromeless =
    isTeamManager ||
    cfg.prodPrefix === "/general-affairs" ||
    cfg.prodPrefix === "/management-dashboard" ||
    cfg.prodPrefix === "/hr-system" ||
    cfg.prodPrefix === "/drive";
  const params: string[] = [];
  if (isChromeless) {
    params.push("embedded=1");
  }
  if (isTeamManager && ctx.selectedTeamId) {
    params.push(`teamId=${encodeURIComponent(ctx.selectedTeamId)}`);
  }
  // 경영 대시보드 디자인 검토: admin이 ?demo=1로 열렸으면 iframe에도 전달.
  if (ctx.forceDemo && cfg.prodPrefix === "/management-dashboard") {
    params.push("demo=1");
  }
  if (ctx.reloadKey > 0) {
    params.push(`_=${ctx.reloadKey}`);
  }
  if (params.length === 0) {
    return base;
  }
  const sep = base.includes("?") ? "&" : "?";
  return `${base}${sep}${params.join("&")}`;
}
